<template>
	<div
		:class="[
			'radiobutton-button',
			type === 'pricelist' ? 'radiobutton-button--pricelist' : ''
		]"
	>
		<label>
			<input
				type="radio"
				:id="this.id"
				:name="this.name"
				:value="this.value"
				:checked="this.isChecked"
				:disabled="this.isDisabled"
				@click="
					getValue(
						$event.target.id,
						$event.target.value,
						startdayname,
						enddayname,
						length,
						fromdate,
						todate
					)
				"
			/>
			<span class="radiobutton-button__text">{{ text }}</span>
			<span v-if="tooltip && !isDisabled" class="radiobutton-button__tooltip">
				{{ tooltip }}
			</span>
		</label>
	</div>
</template>

<script>
export default {
	name: 'RadionButtonButton',
	props: {
		value: {
			type: String,
			default: ''
		},
		fromdate: {
			type: String,
			default: ''
		},
		todate: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: ''
		},
		id: {
			type: Number,
			default: 0
		},
		text: {
			type: String,
			default: ''
		},
		tooltip: {
			type: String,
			Default: ''
		},
		startdayname: {
			type: String,
			default: ''
		},
		enddayname: {
			type: String,
			default: ''
		},
		length: {
			type: Number,
			default: 0
		},
		model: {
			type: Array,
			default: () => []
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		isChecked: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		getValue(id, value, startdayname, enddayname, length, fromdate, todate) {
			this.$emit(
				'selected',
				id,
				value,
				startdayname,
				enddayname,
				length,
				fromdate,
				todate
			)
		}
	}
}
</script>

<style scoped lang="scss">
.radiobutton-button {
	display: inline-block;
	border: 1px solid rgba(42, 62, 97, 0.2);
	border-radius: 3px;
	background-color: #ffffff;
	box-shadow: inset 0 0 1px 0 rgba(0, 0, 0, 0.2);
	color: $colorPrimary;
	font-family: Saira;
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 21px;
	// margin: 0 5px 5px 0;
	margin: 0;
	position: relative;

	// @include for-tablet-landscape-up {
	// 	margin: 0 5px 0 0;
	// }

	label {
		float: left;
		cursor: pointer;
	}

	label input + span {
		display: block;
		padding: 4px 10px;
		border-radius: 3px;
	}

	label input {
		// position:absolute;
		// top:-20px;
		display: none;
	}

	input:checked + span {
		background-color: $colorPrimary;
		color: $colorPrimary1;
	}
	input:disabled + span {
		background: $colorGrey1;
		color: $colorPrimary3;
		cursor: context-menu;
	}

	&__text {
		display: inline-block;
		vertical-align: middle;
		margin-top: 0;
		transition: margin 0.2s;
	}

	&__color {
		display: inline-block;
		height: 12px;
		width: 12px;
		border-radius: 2px;
		margin: 0 8px 0 0;
		vertical-align: middle;
	}

	&__tooltip {
		display: block;
		opacity: 0;
		z-index: 1;
		position: absolute;
		bottom: -28px;
		left: calc(50% - 50px);
		width: 100px;
		background: $colorPrimary;
		padding: 3px 5px;
		font-size: 12px;
		font-weight: 300;
		color: $colorWhite;
		text-align: center;
		box-sizing: border-box;
		border-radius: 3px;
		box-shadow: 6px 9px 20px -7px rgba(161, 161, 161, 1);
		transition: all 0.2s;

		&:before {
			content: '';
			display: block;
			width: 0;
			height: 0;
			border-left: 6px solid transparent;
			border-right: 6px solid transparent;
			border-bottom: 5px solid $colorPrimary;
			position: absolute;
			top: -4px;
			left: calc(50% - 3px);
			z-index: 30;
		}
	}

	&:hover {
		.radiobutton-button__text {
			margin-top: -3px;
		}
		.radiobutton-button__tooltip {
			opacity: 1;
			bottom: -20px;
		}
	}

	&--pricelist {
		background-color: $colorGreen;
		color: $colorWhite;
		font-size: 18px;
		font-weight: 600;
		transition: 0.2s background-color;
		border-radius: 3px;
		position: relative;
		border: none;
		width: 100%;

		label {
			height: 40px;
			width: 100%;
		}

		label input + span {
			line-height: 37px;
			border: none;
			box-sizing: border-box;
			padding: 0 10px;
			text-align: center;
			white-space: nowrap;
			border: 2px solid transparent;
		}

		input:checked + span {
			background-color: $colorGreen;
			color: $colorWhite;
			border-color: $colorPrimary;
		}

		input:disabled + span {
			background-color: #ffffff;
			border: 1px dashed #bfc5cf;
			color: #7f8ba1;
			font-size: 14px;
			font-weight: 400;
			box-shadow: none;
			cursor: context-menu;
		}

		&:hover {
			background-color: darken($color: $colorGreen, $amount: 20);
		}

		@include for-tablet-landscape-up {
			label input + span {
				padding: 0 30px;
			}

			&--pricelist {
				label {
					min-width: 160px;
				}
				label input + span {
					min-width: 160px;
				}
			}
		}
	}
}
</style>
